import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import '../WebflowCss/normalize.css';
import '../WebflowCss/webflow.css';
import WaitingLady from '../assets/images/Picture_WaitingLady.png';
import { RoundButton } from './Common';

export const SlowSection = () => {
  return (
    <div className="slow-section">
      <div className="presenter-container">
        <div className="shadow-box">
          <div className="shadow-con-left">
            <div className="div-block-9">
              <div className="slow-custom">slow</div>
              <div className="red-line"></div>
            </div>
            <div className="text-block-40">Say bye to slow with FastTransfer</div>
            <div className="text-block-25">
              Gone are the times in which you have been waiting for your transactions to transfer. Here are the times you have been waiting for,
              worldwide Transfers in seconds. So you have more time for the Things in live that really matter!
            </div>
            <RoundButton text="What FastTransfer can do for your Business" onClick />
          </div>
          <img src={WaitingLady} loading="lazy" height="" alt="" className="box-image-right" />
        </div>
      </div>
    </div>
  );
};
